import React from 'react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  const isForYou = ['Querés bajar de peso pero el cardio te destruye las rodillas', 'Ya probaste mil dietas y siempre terminás en lo mismo', 'Tenés poco tiempo y necesitás algo corto que puedas sostener', 'Sentís el cuerpo hinchado, pesado y sin energía', 'Querés verte mejor pero sin matarte entrenando'];
  const notForYou = ['Buscás resultados sin hacer nada', 'Querés bajar 10 kilos en una semana', 'No estás dispuesta a dedicar 20 minutos al día'];
  return <section className="py-12 md:py-16 bg-gray-900 text-white" data-id="element-98">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-99">

        {/* Es para vos si… */}
        <div className="mb-10" data-id="element-100">
          <h2 className="font-display text-3xl md:text-4xl text-center mb-8" data-id="element-101">
            ¿Es para vos?
          </h2>
          <div className="bg-gray-800 rounded-2xl p-6 mb-4" data-id="element-102">
            <p className="text-brand-pink-400 font-bold uppercase text-xs tracking-widest mb-4" data-id="element-103">
              ✅ Este programa es para vos si…
            </p>
            <div className="space-y-3" data-id="element-104">
              {isForYou.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-105">
                  <span className="text-emerald-400 font-bold flex-shrink-0" data-id="element-106">✓</span>
                  <p className="text-gray-200 text-sm" data-id="element-107">{item}</p>
                </div>)}
            </div>
          </div>
          <div className="bg-gray-800 rounded-2xl p-6" data-id="element-108">
            <p className="text-gray-400 font-bold uppercase text-xs tracking-widest mb-4" data-id="element-109">
              ❌ No es para vos si…
            </p>
            <div className="space-y-3" data-id="element-110">
              {notForYou.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-111">
                  <span className="text-rose-400 font-bold flex-shrink-0" data-id="element-112">✗</span>
                  <p className="text-gray-400 text-sm" data-id="element-113">{item}</p>
                </div>)}
            </div>
          </div>
        </div>

        {/* CTA final */}
        <div className="text-center" data-id="element-114">
          <p className="font-display text-3xl md:text-4xl mb-2" data-id="element-115">
            Tu cuerpo no necesita otro<br data-id="element-116" />
            <span className="text-brand-pink-400" data-id="element-117">"empiezo el lunes"</span>
          </p>
          <p className="text-gray-400 text-base mb-8" data-id="element-118">
            Necesita un método real. 20 minutos al día. Desde casa.
          </p>

          <div className="bg-gray-800 rounded-2xl p-6 mb-6" data-id="element-119">
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-1" data-id="element-120">Oferta termina en</p>
            <div className="mb-4" data-id="element-121">
              <CountdownTimer data-id="element-122" />
            </div>
            <p className="text-gray-400 line-through text-sm mb-1" data-id="element-123">Valor real: $139.890</p>
            <p className="text-5xl font-black text-brand-pink-500 leading-none mb-4" data-id="element-124">$14.990</p>
            <CTAButton size="large" className="w-full" data-id="element-125">
              QUIERO EMPEZAR AHORA
            </CTAButton>
            <p className="text-xs text-gray-500 mt-3" data-id="element-126">🛡️ Garantía 7 días · Acceso inmediato · Desde el celular</p>
          </div>
        </div>
      </div>
    </section>;
}